import React from 'react'
import AwesomeSlider from 'react-awesome-slider'
import 'react-awesome-slider/dist/styles.css'
import 'react-awesome-slider/dist/custom-animations/cube-animation.css'
import imagen2 from '../../../static/tq12.jpg'
import imagen3 from '../../../static/tq11.jpg'
import imagen4 from '../../../static/tq10.jpg'
import imagen5 from '../../../static/tq9.jpg'
import imagen6 from '../../../static/tq6.jpg'
import imagen7 from '../../../static/tq.jpg'
import imagen8 from '../../../static/TQ5.jpg'
import imagen9 from '../../../static/Tq2.jpg'
import imagen10 from '../../../static/tq1.jpg'

function random (min, max) {
  min = Math.ceil(min)
  max = Math.floor(max)
  const aleatorio = Math.random() * (max - min + 1) + min
  return aleatorio | 0
}

function Carousel () {
  return (
    <AwesomeSlider
      play
      selected={random(0, 7)}
      cancelOnInteraction={false}
      interval={10}
      bullets={false}
      fillParent
      mobileTouch
    >
      <div data-src={imagen2} />
      <div data-src={imagen3} />
      <div data-src={imagen4} />
      <div data-src={imagen5} />
      <div data-src={imagen7} />
      <div data-src={imagen6} />
      <div data-src={imagen8} />
      <div data-src={imagen9} />
      <div data-src={imagen10} />
    </AwesomeSlider>
  )
}

export default Carousel
